export default __webpack_public_path__ + "static/Plots0018-ca436826b014ed8174bfafe349904bb4.jpg";